var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"cm-mg-p-wzd text-center text-muted"},[_vm._v("\n    "+_vm._s(_vm.$t('vie.Pag.Das.Bus.ste.SecondStep.text1'))+"\n  ")]),_c('hr'),_c('select-address',{ref:"selectAddress",attrs:{"requiredFields":_vm.requireAddress,"showZipCode":false},on:{"showHideLoading":_vm.showHideLoading,"onChange":_vm.handleChangeSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }